import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  margin-top: 12px;
  margin-bottom: 4px;
  text-align: left;

  p {
    display: flex;
    line-height: 24px;
  }

  label {
    margin-left: 12px;
    font-size: 1rem;
  }

  input[type='checkbox'] {
    margin-left: 0;
    vertical-align: middle;
    flex-shrink: 0;
  }

  a {
    font-weight: normal;
  }
`

const FormCheckboxContainer = (props: Parameters<typeof Wrapper>[0]) => (
  <Wrapper>
    <p>{props.children}</p>
  </Wrapper>
)

export default FormCheckboxContainer
